import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {DayPipe} from './pipes/day.pipe';
import {HourPipe} from './pipes/hour.pipe';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SeeMoreScrollDirective} from '../directives/see-more-scroll.directive';
import {FilterCountPipe} from './pipes/filter-count.pipe';

@NgModule({
  imports: [CommonModule, MatCheckboxModule, FormsModule, ReactiveFormsModule],
  bootstrap: [],
  declarations: [
    // SearchOpenhoursFilterComponent,
    // SearchAttributesFilterComponent,
    // SearchTimeslotsFilterComponent,
    // SearchCustomerFeatureFilterComponent,
    // SearchFiltersDesktopPanelComponent,
    FilterCountPipe,
    DayPipe,
    HourPipe,
    SeeMoreScrollDirective,
  ],
  exports: [
    // SearchOpenhoursFilterComponent,
    // SearchAttributesFilterComponent,
    // SearchTimeslotsFilterComponent,
    // SearchCustomerFeatureFilterComponent,
    // SearchFiltersDesktopPanelComponent,
    FilterCountPipe,
    DayPipe,
    HourPipe,
    SeeMoreScrollDirective,
  ],
})
export class SharedSearchModule {}
